import React, { useState } from "react";
import { useEffect } from "react";
import styled from "styled-components";

const BasicSlider = ({ onChange, value }) => {
  // const [value, setValue] = useState(0);
  const [bgC, setBgC] = useState('');

  const handleChange = (event) => {
    const newValue = Number(event.target.value);
    // setValue(newValue);
    onChange && onChange(newValue);
  };
  
  useEffect(() => {
    const val = (value - 0)/(100 - 0) * 100;
    setBgC('linear-gradient(to right, #32DE86 0%, #32DE86 ' + val + '%, #fff ' + val + '%, #303030 0%)')    
  }, [value])
  
  
  return (
    <Wrapper>
    <div className="basic-slider-container">
      <input
        className="slider"
        type="range"
        min={0}
        max={100}
        value={value}
        onChange={handleChange}
        style={{ backgroundImage: `${bgC}` }}
      />
    </div>
    </Wrapper>
  );
};

export default BasicSlider;

const Wrapper = styled.div`

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 2px;
  background: #32DE86;
  outline: none;
  border-radius: 1px;  
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  background: #32DE86;
  border-radius: 50%;
  cursor: pointer;
}

`